<template>
    <div class="bigdata_container" id="bigdata" v-loading="isLoading" element-loading-text="拼命加载中..."
        element-loading-background="rgba(0, 0, 0, 0.8)">
        <div class="header">
            {{ orgName }}数据大屏
        </div>
        <div class="time">{{ currentTime }}</div>
        <div class="quanp">
            <!-- <el-button id="fullScreen" @click="showFullScreen" type="primary">{{
                onFullScreen ? "退出全屏" : "进入全屏"
            }}</el-button> -->
            <img src="../../../assets/img/homecare/screen.png" @click="showFullScreen" class='screen' />
        </div>
        <div class="serach_wrapper">
            <treeselect v-model="regionId" :options="deptOptions" :normalizer="normalizer" :appendToBody="true"
                z-index="9999" placeholder="请选择区域" @select="deptSelect" style="width: 140px; height: 26px" />
            <img src="../../../assets/img/homecare/search.png" @click="handleSearch('search')"
                style="position:absolute;cursor: pointer;width:20px;height:20px;margin-top:3px;margin-left:152px" />
        </div>

        <transition name="nameoftransition">
            <div class="info_tisp" v-show="infoTisp">
                <i class="el-message__icon el-icon-info"></i>未搜索到相关数据
            </div>
        </transition>
        <div class="bigdata_main" v-if="oldIndex === 0">
            <div id="container" style="width: 100%; height: 100%;margin-top:20px"></div>
            <div class="main_left">
                <div class="main_pane main_pane1">
                    <div class="titleHeader">
                        <div class="titleIcon">
                            <!-- <img src="../assets/img/title_icon.png" alt="" /> -->
                        </div>
                        <div class="titleTxt">残疾类型</div>
                    </div>
                    <div class="typeBox">
                        <ul>
                            <li>
                                <div class="type">
                                    <span></span>类型
                                </div>
                                <div id="typeChart" style='height:90%;width:100%'></div>
                            </li>
                            <li>
                                <div class="type">
                                    <span></span>等级
                                </div>
                                <div id="degreeChart" style='height:98%;width:100%'></div>
                            </li>
                        </ul>
                    </div>
                </div>
                <!-- 老人类别统计 -->
                <div class="main_pane main_pane2" style="margin-top: 20px">
                    <div class="titleHeader">
                        <div class="titleIcon">
                            <!-- <img src="../assets/img/title_icon.png" alt="" /> -->
                        </div>
                        <div class="titleTxt">{{ serTitle }}</div>
                    </div>
                    <ul class="disabledtype">
                        <li v-for="(v, i) in serOldlist" :key='i' :class="[serIndex === i ? 'active' : '']"
                            @click="serClick(i)">{{ v.label }}</li>
                    </ul>
                    <div id="echartsTwo" ref="echartsTwo" style="height: 30vh; width: 100%;margin-top:12px;"
                        v-if="serIndex === 0"></div>
                    <div id="echartsFour" ref="echartsFour" v-if="serIndex === 1"
                        style="height: 76%; width: 100%;margin-top:12px"></div>
                </div>
            </div>
            <div class="main_center">
                <div class="map">
                    <ul class="datatype">
                        <li>
                            <div class="data">{{ totallist.serviceTimeCount }}/<span class="unit">小时</span></div>
                            <span>服务总时长</span>
                        </li>
                        <li>
                            <div class="data">{{ totallist.serviceCustomerCount }}/<span class="unit">人</span></div>
                            <span>已服务人数</span>
                        </li>
                        <li>
                            <div class="data">{{ totallist.clOrderCount }}/<span class="unit">单</span></div>
                            <span>残联工单总数</span>
                        </li>
                        <li>
                            <div class="data">{{ totallist.staffCount }}/<span class="unit">人</span></div>
                            <span>服务人员数量</span>
                        </li>
                        <li>
                            <div class="data">{{ totallist.useCustomerCount }}/<span class="unit">人</span></div>
                            <span>在用服务对象数量</span>
                        </li>
                    </ul>
                </div>
                <div class="serviceBg">
                    <div class="cont">
                        <div v-for="(v, i) in oldType" :key="i" :class="[oldIndex === i ? 'active' : '']"
                            @click='oldClick(i)'>
                            {{ v.name }}</div>
                    </div>
                </div>
            </div>

            <div class="main_right">
                <!-- 残疾类型 -->
                <div class="main_pane main_pane4">
                    <div class="titleHeader">
                        <div class="titleIcon">
                            <!-- <img src="../assets/img/title_icon.png" alt="" /> -->
                        </div>
                        <div class="titleTxt">人员情况</div>
                    </div>
                    <ul class="disabledtype">
                        <li v-for="(v, i) in disList" :key='i' :class="[disIndex === i ? 'active' : '']"
                            @click="disClick(i)">
                            {{ v.label }}</li>
                    </ul>
                    <div id="echartsThree" ref="echartsThree" style="height: 75%; width: 100%;"></div>
                </div>
                <!-- 服务工单类型 -->
                <div class="main_pane main_pane5" style="margin-top: 20px">
                    <div class="titleHeader">
                        <div class="titleIcon">
                            <!-- <img src="../assets/img/title_icon.png" alt="" /> -->
                        </div>
                        <div class="titleTxt">特色风采</div>
                    </div>
                    <el-carousel style="height:36vh;margin-top:10px">
                        <el-carousel-item v-for="(v, i) in speciList" :key="i" style="height:100%">
                            <img :src="v.url" style="height:82%;width:100%" />
                            <h3 class="small">{{ v.name }}</h3>
                        </el-carousel-item>
                    </el-carousel>
                </div>

            </div>
        </div>
        <serviceOld v-else @refreshClick="refreshClick" ref="oldForm"></serviceOld>
        <el-dialog :title="infotitle" :visible.sync="dialogVisible" width="30%" custom-class="speinfo"
            style='margin-top:28vh;' :before-close="handleClose">
            <div class="top">
                <div class="left">
                    <img :src="infoData.personPhoto" class='img' />
                    <div class="info">
                        <p v-if="typeValue == 2">站点名称：{{ infoData.statName }}</p>
                        <p v-else>姓名：{{ infoData.personName }}</p>
                        <p>联系方式：{{ infoData.personPhone }}</p>
                        <p class="add"><span class="first">地址：</span><span>{{ infoData.address }}</span></p>
                        <p v-if="typeValue == 3">残疾类型：
                            <span v-if="infoData.disabilityType == 1">视力残疾</span>
                            <span v-if="infoData.disabilityType == 2">听力残疾</span>
                            <span v-if="infoData.disabilityType == 3">言语残疾</span>
                            <span v-if="infoData.disabilityType == 4">肢体残疾</span>
                            <span v-if="infoData.disabilityType == 5">智力残疾</span>
                            <span v-if="infoData.disabilityType == 6">智力残疾</span>
                            <span v-if="infoData.disabilityType == 7">智力残疾</span>
                        </p>
                        <p v-if="typeValue == 3">残疾等级：
                            <span v-if="infoData.diSabiLityLeveL == 1">一级残疾</span>
                            <span v-if="infoData.diSabiLityLeveL == 2">二级残疾</span>
                            <span v-if="infoData.diSabiLityLeveL == 3">三级残疾</span>
                            <span v-if="infoData.diSabiLityLeveL == 4">四级残疾</span>
                        </p>
                    </div>
                </div>
                <!-- <div class="right" @click="showVideo">视频通话</div> -->
            </div>
        </el-dialog>
        <!-- 弹窗 end -->
        <shipingtonghua v-if="videoModal" :userId="userinfo.id" :mobilePhone='userinfo.personPhone'
            :closeSP.sync="videoModal"></shipingtonghua>
    </div>
</template>
<script>
import request from "@/utils/request.js"
import baseURL from "@/api/baseURL"
import * as echarts from "echarts"
import shipingtonghua from "@/components/shipingtonghua.vue"
import serviceOld from "./service.vue"
export default {
    name: "visualized",
    components: {
        shipingtonghua,
        serviceOld
    },
    data() {
        return {
            currentTime: '',
            timeC: null,
            infoTisp: false,
            isLoading: false,
            keyword: "", //搜索
            onFullScreen: false, // 是否全屏
            echartOne: null, // 残疾类型
            echartTwo1: null, // 残疾等级
            echartThree1: null, // 七天服务数量
            echartFour1: null, // 服务工单类型
            echartFive: null, // 服务工单类型
            personNum: [],
            productName: [],
            productDate: [],
            selfDate: [],
            oldService: [],
            providerPersonList: [],
            textList: [], //老人评价
            map: null, //地图实例
            formationInfoList: [], //改造信息列表
            markers: [], //地图标记点
            dialogVisible: false,
            stepIndex: 1,
            dialogTitle: "",
            formData: {
                name: "",
                sex: "",
                age: "",
                idCode: "",
                phone: "",
                olderType: "",
            },
            // 图片预览
            dialogImageUrl: "",
            nameList: [],
            seriesData: [],
            // 上传图片地址
            actionUrl:
                baseURL + "/ypt/controller/uploadController/info/uploadPhoto",
            imageUrl: "",
            disList: [
                { label: '男女比例', value: 0 },
                { label: '婚姻状况', value: 1 },
                { label: '居住类型', value: 2 }
            ],
            serOldlist: [
                { label: '七天服务数量', value: 0 },
                { label: '服务工单类型', value: 0 }
            ],
            serTitle: '七天服务数量',
            serIndex: 0,
            disIndex: 0,
            typeList1: [],
            degreeLits: [],
            totallist: {},
            comList: [],
            stateList: [],
            dayList: [],
            serviceList: [],
            speciList: [],
            cid: '',
            orgList: [],
            serviceData: [],
            stationData: [],
            customeData: [],
            userinfo: {},
            videoModal: false,
            infoData: {},
            typeValue: null,
            regionId: '',
            regionName: '',
            polygons: [],
            regionList: [
                { name: '淮安区', id: '1001' },
                { name: '盱眙县', id: '1002' },
                { name: '清江浦区', id: '1003' },
                { name: '淮安区', id: '1009' },
                { name: '涟水县', id: '1011' },
                { name: '金湖县', id: '1012' },
                { name: '洪泽区', id: '1013' }
            ],
            deptOptions: [],
            oldType: [
                {
                    name: '残联居家', value: 0
                },
                {
                    name: '服务工单',
                }
            ],
            oldIndex: 0,
            infotitle: '',
            orgName: ''
        }
    },
    async created() {
        this.orgName = this.$store.state.info.orgName
        this.regionId = this.$store.state.info.orgId
        this.cid = this.regionId
    },
    async mounted() {
        this.$nextTick(() => {
            this.echartsThree()
        })
        let self = this
        await self.loadMap()
        //   self.getServiceProvider()
        window.addEventListener("resize", () => {
            // 自适应所有echarts
            const handleResize = () => {
                if (!checkFull()) {
                    self.onFullScreen = false
                }
            }
            window.onresize = handleResize
            function checkFull() {
                let isFull =
                    document.fullscreenElement ||
                    document.mozFullScreenElement ||
                    document.webkitFullscreenElement
                if (isFull === undefined) isFull = false
                return isFull
            }
            self.$nextTick(() => {
                self.echartOne && self.echartOne.resize() // 老人类别统计echarts
                self.echartTwo1 && self.echartTwo1.resize() //改造人数统计echarts
                self.echartThree1 && self.echartThree1.resize() //改造产品统计echarts
                self.echartFour1 && self.echartFour1.resize() //自理类别统计echarts
                self.echartFive && self.echartFive.resize() 
            })
        })
        this.init()
        // const self = this
        document.addEventListener(
            "fullscreenchange",
            function () {
                self.onFulechartOnelScreen =
                    document.fullscreenElement == null ? false : true
            },
            false
        )

        document.addEventListener(
            "msfullscreenchange",
            function () {
                self.onFullScreen =
                    document.fullscreenElement == null ? false : true
            },
            false
        )

        document.addEventListener(
            "mozfullscreenchange",
            function () {
                self.onFullScreen =
                    document.fullscreenElement == null ? false : true
            },
            false
        )
        document.addEventListener(
            "webkitfullscreenchange",
            function () {
                self.onFullScreen =
                    document.fullscreenElement == null ? false : true
            },
            false
        )
    },
    beforeDestroy() {
        // 组件销毁前清除定时器  
        if (this.timer) {
            clearInterval(this.timer);
            this.timer = null;
        }
    },
    filters: {
    },
    _methods: {
        listDept() {
            this.$http
                .request({
                    url: "/rbac/admin/org/info/getUserOrgTree",
                    method: "POST",
                    data: {
                    },
                })
                .then((res) => {
                    console.log(res, 'res')
                    if (res.code === 200) {
                        if (res.content != null) {
                            let arr = [res.content]
                            this.deptOptions = this.handleTree(arr, "deptId");
                        }
                    }
                })
        },
        /** 转换机构数据结构 */
        normalizer(node) {
            if (node.children && !node.children.length) {
                delete node.children;
            }
            return {
                id: node.orgId,
                label: node.label,
                children: node.children,
            };
        },
        deptSelect(item) {
            this.orgName = item.label
        },
        // 获取时间
        getTime() {
            let yy = new Date().getFullYear()
            let mm = new Date().getMonth() + 1 < 10 ? "0" + (new Date().getMonth() + 1) : new Date().getMonth() + 1
            let dd = new Date().getDate() < 10 ? "0" + new Date().getDate() : new Date().getDate()
            let hh = new Date().getHours() < 10 ? "0" + new Date().getHours() : new Date().getHours()
            let mf = new Date().getMinutes() < 10 ? "0" + new Date().getMinutes() : new Date().getMinutes()
            let ss = new Date().getSeconds() < 10 ? "0" + new Date().getSeconds() : new Date().getSeconds()
            this.currentTime = yy + "-" + mm + "-" + dd + " " + hh + ":" + mf + ":" + ss
        },
        currentTime1() {
            setInterval(this.getTime, 500)
        },

        //残疾类型
        getOneList() {
            this.$http
                .request({
                    url: "/jjyl/admin/clBigScreen/info/findDisableType",
                    method: "POST",
                    data: {
                        id: this.cid,
                        orgType: 499
                    },
                })
                .then((res) => {
                    if (res.code === 200) {
                        if (res.content != null) {
                            this.typeList1 = res.content
                            this.getcType(this.typeList1)
                        }
                    }
                })
        },
        // 残疾等级
        getTwoList() {
            this.$http
                .request({
                    url: "/jjyl/admin/clBigScreen/info/findDisableLevel",
                    method: "POST",
                    data: {
                        id: this.cid,
                        orgType: 499
                    },
                })
                .then((res) => {
                    if (res.code === 200) {
                        if (res.content != null) {
                            this.degreeLits = res.content
                            this.getcGegree()
                        }
                    }
                })
        },
        // 居中数量统计
        getThreeList() {
            this.$http
                .request({
                    url: "/jjyl/admin/clBigScreen/info/findCenterCountStat",
                    method: "POST",
                    data: {
                        id: this.cid,
                        orgType: 499
                    },
                })
                .then((res) => {
                    if (res.code === 200) {
                        if (res.content != null) {
                            this.totallist = res.content
                        }
                    }
                })
        },
        // 查询男女比例
        getFourList() {
            this.$http
                .request({
                    url: "/jjyl/admin/clBigScreen/info/findGenderPercent",
                    method: "POST",
                    data: {
                        id: this.cid,
                        orgType: 499
                    },
                })
                .then((res) => {
                    if (res.code === 200) {
                        if (res.content != null) {
                            this.comList = res.content
                            this.echartsThree(this.comList)
                        }
                    }
                })
        },
        // 查询婚姻
        gethyList() {
            this.$http
                .request({
                    url: "jjyl/admin/clBigScreen/info/findMarriageStatus",
                    method: "POST",
                    data: {
                        id: this.cid,
                        orgType: 499
                    },
                })
                .then((res) => {
                    if (res.code === 200) {
                        if (res.content != null) {
                            this.comList = res.content
                            this.echartsThree(this.comList)
                        }
                    }
                })
        },
        // 查询居住
        getLiveList() {
            this.$http
                .request({
                    url: "/jjyl/admin/clBigScreen/info/findLifeArea",
                    method: "POST",
                    data: {
                        id: this.cid,
                        orgType: 499
                    },
                })
                .then((res) => {
                    if (res.code === 200) {
                        if (res.content != null) {
                            this.comList = res.content
                            this.echartsThree(this.comList)
                        }
                    }
                })
        },
        // 查询近7天每天工单数据
        getdayList() {
            this.$http
                .request({
                    url: "/jjyl/admin/clBigScreen/info/findNearSevenDayOrder",
                    method: "POST",
                    data: {
                        id: this.cid,
                        orgType: 499
                    },
                })
                .then((res) => {
                    if (res.code === 200) {
                        if (res.content != null) {
                            this.
                                dayList = res.content
                            this.echartsTwo(this.dayList)
                        }
                    }
                })
        },
        // 查询工单数据
        getserList() {
            this.$http
                .request({
                    url: "/jjyl/admin/clBigScreen/info/findOrderType",
                    method: "POST",
                    data: {
                        id: this.cid,
                        orgType: 499
                    },
                })
                .then((res) => {
                    if (res.code === 200) {
                        if (res.content != null) {
                            this.serviceList = res.content
                            this.echartsFour(this.serviceList)
                        }
                    }
                })
        },
        //特色风采
        getSpeList() {
            this.$http
                .request({
                    url: "/jjyl/admin/clBigScreen/info/findClCharacteristics",
                    method: "POST",
                    data: {
                        id: this.cid,
                        type: 695
                    },
                })
                .then((res) => {
                    if (res.code === 200) {
                        if (res.content != null) {
                            this.speciList = res.content
                        }
                    }
                })
        },
        getcType(data1) {
            var chartDom = document.getElementById("typeChart")
            var myChart = echarts.init(chartDom)
            this.echartOne=myChart
            var option
            option = {
                tooltip: {
                    trigger: 'item',
                    textStyle: {
                        fontSize: 10 // 设置 tooltip 中文本的字体大小  
                    }
                },
                grid: {
                    //   top:'1%',
                    //   containLabel:true
                },
                legend: {
                    top: '54%',
                    left: 'center',
                    textStyle: {
                        color: '#fff',
                        fontSize: 8
                    },
                    itemWidth: 12,
                    itemHeight: 12,
                    itemGap: 8,
                    orient: 'horizontal'
                },
                series: [
                    {
                        name: '',
                        type: 'pie',
                        radius: ['32%', '45%'],
                        center: ['45%', '28%'],
                        // adjust the start and end angle
                        itemStyle: {
                            normal: {
                                labelLine: {
                                    length: 5,
                                    length2: 5,
                                    show: true,
                                    color: '#8CFFF4'
                                }
                            }
                        },
                        label: {
                            normal: {
                                fontSize: 8,
                            }
                        },
                        color: [
                            "#5766EA", "#58B3FF", "#8CFFEF", "#D67DFF", "#FEDB65", "#70FF70", "#FF8A8A"
                        ],
                        data: this.getArray(data1)
                    }
                ]
            };
            option && this.echartOne.setOption(option)
        },
        getArray(disabilityData) {
            const data = [];
            // 遍历对象并收集数据  
            for (const key in disabilityData) {
                if (disabilityData.hasOwnProperty(key)) {
                    data.push({
                        name: key,
                        value: disabilityData[key]
                    });
                }
            }
            return data
        },
        //等级
        getcGegree() {
            var chartDom = document.getElementById("degreeChart")
            var myChart = echarts.init(chartDom)
            this.echartTwo1=myChart
            var option
            option = {
                backgroundColor: "transparent",
                tooltip: {
                    trigger: 'item',
                    textStyle: {
                        fontSize: 10 // 设置 tooltip 中文本的字体大小  
                    }
                },
                grid: {
                    top: '5%',
                },
                legend: {
                    top: '56%',
                    left: 'center',
                    textStyle: {
                        color: '#fff',
                        fontSize: 8
                    },
                    itemWidth: 12,
                    itemHeight: 12
                },
                series: [
                    {
                        name: '',
                        type: 'pie',
                        radius: ['32%', '45%'],
                        center: ['48%', '28%'],
                        itemStyle: {
                            normal: {
                                labelLine: {
                                    length: 5,
                                    length2: 5,
                                    show: true,
                                    color: '#8CFFF4'
                                }
                            }
                        },
                        label: {
                            normal: {
                                fontSize: 8,
                            }
                        },
                        color: [
                            "#5766EA", "#58B3FF", "#8CFFEF", "#D67DFF", "#FEDB65", "#70FF70", "#FF8A8A"
                        ],
                        data: this.getArray(this.degreeLits)
                    }
                ]
            };
            option && this.echartTwo1.setOption(option)
        },
        //残疾类型
        disClick(i) {
            this.disIndex = i
            this.comList = []
            if (i === 0) {
                this.getFourList()
            } else if (i === 1) {
                this.gethyList()
            } else {
                this.getLiveList()
            }
        },
        //跳转页面
        async oldClick(i) {
            this.oldIndex = i
            if (i == 0) {
                if (this.map) {
                    this.map.updateSize(); // 重新计算地图的尺寸
                } else {
                    this.loadMap(); // 如果地图没有加载则加载地图
                }
            }
        },
        refreshClick(i) {
            this.oldIndex = i
            if (i === 0) {
                this.handleSearch()
            }
        },
        //七天工单
        serClick(i) {
            this.serIndex = i
            if (i === 0) {
                this.serTitle = '七天服务数量'
                this.getdayList()
            } else {
                this.serTitle = '服务工单类型'
                this.getserList()
            }
        },
        // 控制全屏展示
        showFullScreen() {
            this.onFullScreen = !this.onFullScreen
            if (this.onFullScreen) {
                var docElm = document.documentElement
                if (docElm.requestFullscreen) {
                    docElm.requestFullscreen()
                } else if (docElm.msRequestFullscreen) {
                    docElm = document.body //overwrite the element (for IE)
                    docElm.msRequestFullscreen()
                } else if (docElm.mozRequestFullScreen) {
                    docElm.mozRequestFullScreen()
                } else if (docElm.webkitRequestFullScreen) {
                    docElm.webkitRequestFullScreen()
                }
            } else {
                if (document.exitFullscreen) {
                    document.exitFullscreen()
                } else if (document.msExitFullscreen) {
                    document.msExitFullscreen()
                } else if (document.mozCancelFullScreen) {
                    document.mozCancelFullScreen()
                } else if (document.webkitCancelFullScreen) {
                    document.webkitCancelFullScreen()
                }
            }
        },
        FullCreeen(element) {
            let el = document.getElementById("bigdata")
            let rfs =
                el.requestFullScreen ||
                el.webkitRequestFullScreen ||
                el.mozRequestFullScreen ||
                el.msRequestFullScreen
            if (typeof rfs != "undefined" && rfs) {
                rfs.call(el)
            } else if (typeof window.ActiveXObject != "undefined") {
                let wscript = new ActiveXObject("WScript.Shell")
                if (wscript != null) {
                    wscript.SendKeys("{F11}")
                }
            }
        },
        formatDate(dateStr) {
            // 将日期字符串从 'YYYY-MM-DD' 格式转换为 'MM.DD' 格式  
            const [year, month, day] = dateStr.split('-').map(Number);
            return `${String(month).padStart(2, '0')}.${String(day).padStart(2, '0')}`;
        },
        // 本月日服务数量
        echartsTwo(datalist) {
            let counts = [];
            let dates = [];
            // 从后往前累加 count 值  
            let cumulativeCount = 0;
            for (let i = datalist.length - 1; i >= 0; i--) {
                counts.unshift(datalist[i].count); // 使用 unshift 在数组开头插入元素  
            }
            // 格式化日期并添加到 dates 数组  
            datalist.forEach(item => {
                const [year, month, day] = item.day.split('-');
                dates.push(`${month.padStart(2, '0')}.${day.padStart(2, '0')}`);
            });
            var chartDom = document.getElementById("echartsTwo")
            var myChart = echarts.init(chartDom)
            this.echartThree1=myChart
            var option
            option = {
                backgroundColor: "transparent",
                tooltip: {
                },
                grid: {
                    top: '4%',
                    left: '2%',
                    right: '7%',
                    bottom: '6%',
                    containLabel: true,
                },
                xAxis: [{
                    type: 'category',
                    boundaryGap: false,
                    axisLine: { //坐标轴轴线相关设置。数学上的x轴
                        show: true,
                        lineStyle: {
                            color: '#233e64'
                        },
                    },
                    axisLabel: { //坐标轴刻度标签的相关设置
                        show: true,
                        interval: 0,
                        textStyle: {
                            color: '#B7C4D8',
                            margin: 15,
                        },
                    },
                    axisTick: { show: false, },
                    data: dates,
                }],
                yAxis: [{
                    type: 'value',
                    splitNumber: 7,
                    splitLine: {
                        show: true,
                        lineStyle: {
                            color: '#233e64'
                        }
                    },
                    axisLine: { show: false, },
                    axisLabel: {
                        margin: 20,
                        textStyle: {
                            color: '#6a9cd5',

                        },
                    },
                    axisTick: { show: false, },
                }],
                series: [{
                    name: '异常流量',
                    type: 'line',
                    smooth: true, //是否平滑曲线显示
                    // 			symbol:'circle',  // 默认是空心圆（中间是白色的），改成实心圆
                    symbolSize: 0,

                    lineStyle: {
                        normal: {
                            color: "#3deaff"   // 线条颜色
                        }
                    },
                    areaStyle: { //区域填充样式
                        normal: {
                            //线性渐变，前4个参数分别是x0,y0,x2,y2(范围0~1);相当于图形包围盒中的百分比。如果最后一个参数是‘true’，则该四个值是绝对像素位置。
                            color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
                                { offset: 0, color: 'rgba(61,234,255, 0.9)' },
                                { offset: 0.7, color: 'rgba(61,234,255, 0)' }
                            ], false),

                            shadowColor: 'rgba(53,142,215, 0.9)', //阴影颜色
                            shadowBlur: 20 //shadowBlur设图形阴影的模糊大小。配合shadowColor,shadowOffsetX/Y, 设置图形的阴影效果。
                        }
                    },
                    data: counts
                }]
            }
            option && this.echartThree1.setOption(option)
        },
        echartsThree(nameList) {
            let arraylist = this.getArray(nameList)
            let nameD = []
            var istotal = 0
            arraylist.forEach((item) => {
                nameD.push(item.name)
                istotal += item.value
            })
            if (istotal === 0) {
                return false
            }
            var chartDom = document.getElementById("echartsThree")
            var myChart = echarts.init(chartDom)
            this.echartFive=myChart
            var option
            let value = '比例'
            var img = ''
            var trafficWay = arraylist
            var data = [];
            var color = ['#00ffff', '#00cfff', '#006ced', '#ffe000', '#ffa800', '#ff5b00', '#ff3000']
            for (var i = 0; i < trafficWay.length; i++) {
                data.push({
                    value: trafficWay[i].value,
                    name: trafficWay[i].name,
                    itemStyle: {
                        normal: {
                            borderWidth: 5,
                            shadowBlur: 20,
                            borderColor: color[i],
                            shadowColor: color[i]
                        }
                    }
                }, {
                    value: 2,
                    name: '',
                    itemStyle: {
                        normal: {
                            label: {
                                show: false
                            },
                            labelLine: {
                                show: false
                            },
                            color: 'rgba(0, 0, 0, 0)',
                            borderColor: 'rgba(0, 0, 0, 0)',
                            borderWidth: 0
                        }
                    }
                });
            }
            var seriesOption = [{
                name: '',
                type: 'pie',
                clockWise: false,
                radius: ['34%', '40%'],
                center: ['48%', '38%'],
                hoverAnimation: false,
                itemStyle: {
                    normal: {
                        label: {
                            show: true,
                            position: 'outside',
                            color: '#ddd',
                            formatter: function (params) {
                                var percent = 0;
                                var total = 0;
                                for (var i = 0; i < trafficWay.length; i++) {
                                    total += trafficWay[i].value;
                                }
                                if (total === 0) {
                                    return ''; // 当没有有效数据时，返回空
                                }
                                if (params.value === 0) {
                                    percent = 0
                                } else {
                                    percent = ((params.value / total) * 100).toFixed(0);
                                }
                                if (params.name !== '') {
                                    return + percent + '%';
                                } else {
                                    return '';
                                }
                            },
                        },
                        labelLine: {
                            length: 10,
                            length2: 20,
                            show: true,
                            color: '#8CFFF4'
                        }
                    }
                },
                data: data
            }];
            option = {
                backgroundColor: 'transparent',
                color: color,
                title: {
                    text: '比例',
                    top: '34%',
                    textAlign: "center",
                    left: "46%",
                    textStyle: {
                        color: '#C9C9C9',
                        fontSize: 16,
                        fontWeight: '400'
                    }
                },
                grid: {
                    top: '3%',
                    bottom: '3%'
                },
                graphic: {
                    elements: [{
                        type: "image",
                        z: 3,
                        style: {
                            image: img,
                            width: 178,
                            height: 178
                        },
                        left: 'center',
                        top: 'center',
                        position: [100, 100]
                    }]
                },
                tooltip: {
                    show: false
                },
                legend: {
                    orient: 'horizontal',
                    // x: 'left',
                    data: nameD,
                    bottom: '8%',
                    left: 'center',
                    textStyle: {
                        color: '#fff',
                        fontSize: 10
                    },
                    itemWidth: 14,
                    itemHeight: 14
                },
                toolbox: {
                    show: false
                },
                series: seriesOption
            }
            option && this.echartFive.setOption(option)
        },
        echartsFour(datalist) {
            let counts = [];
            let lables = [];
            // 从后往前累加 count 值  
            for (let i = datalist.length - 1; i >= 0; i--) {
                counts.unshift(datalist[i].count); // 使用 unshift 在数组开头插入元素  
            }
            // 格式化日期并添加到 dates 数组  
            datalist.forEach(item => {
                lables.push(item.type);
            });
            var chartDom = document.getElementById("echartsFour")
            var myChart = echarts.init(chartDom)
            this.echartFour1=myChart
            var option
            option = {
                backgroundColor: 'transparent',
                grid: {
                    left: '3%',
                    right: '4%',
                    bottom: '5%',
                    top: '4%',
                    containLabel: true
                },
                xAxis: [{
                    type: 'category',
                    data: lables,
                    axisLine: {
                        show: true,
                        lineStyle: {
                            color: "rgba(153, 249, 255, 0.08)",
                            width: 1,
                            type: "solid"
                        }
                    },
                    axisTick: {
                        show: false
                    },
                    axisLabel: {
                        show: true,
                        interval: 0,
                        rotate: 40,
                        textStyle: {
                            color: "#B7C4D8",
                            fontSize: 10
                        }
                    }
                }],
                yAxis: [{
                    type: 'value',
                    axisLabel: {
                        formatter: '{value}',
                        fontSize: 10
                    },
                    axisLine: {
                        show: false,
                        lineStyle: {
                            color: "#00c7ff",
                            width: 1,
                            type: "solid"
                        },
                    },
                    axisTick: {
                        show: false
                    },
                    splitLine: {
                        lineStyle: {
                            color: "rgba(153, 249, 255, 0.08)",
                        }
                    }
                }],
                series: [{
                    type: 'bar',
                    data: counts,
                    barWidth: 12, //柱子宽度
                    //barGap: 1, //柱子之间间距
                    itemStyle: {
                        normal: {
                            color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [{
                                offset: 0,
                                color: '#57EAE7'
                            }, {
                                offset: 1,
                                color: 'rgba(87,234,231,0)'
                            }]),
                            opacity: 1,
                        }
                    }
                }]
            }
            option && this.echartFour1.setOption(option)
        },
        handleClose() {
            this.dialogVisible = false
        },
        showVideo() {
            this.userinfo = this.infoData
            this.videoModal = true
        },
        //获取服务人员打点
        getService() {
            this.$http
                .request({
                    url: "/jjyl/admin/serviceStaffCustomerCenter/info/findList",
                    method: "POST",
                    data: {
                        pageNo: 1,
                        pageSize: 10000,
                        dataId: this.cid,
                        orgType: 695
                    },
                })
                .then((res) => {
                    if (res.code === 200) {
                        if (res.content != null) {
                            this.serviceData = res.content.elderList.list || []
                            let data = this.serviceData.filter(
                                (item) => item.longitude && item.latitude
                            )
                            this.renderMapMarker(data, 1)
                        }
                    }
                })
        },
        //获取服务站打点
        getStation() {
            this.$http
                .request({
                    url: "/jjyl/admin/serviceStation/info/findList",
                    method: "POST",
                    data: {
                        pageNo: 1,
                        pageSize: 10000,
                        dataId: this.cid,
                        type: 695
                    },
                })
                .then((res) => {
                    if (res.code === 200) {
                        if (res.content != null) {
                            this.stationData = res.content.list || []
                            let data = this.stationData.filter(
                                (item) => item.addressLng && item.addressLat
                            )
                            data.forEach((item) => {
                                item.longitude = item.addressLng
                                item.latitude = item.addressLat
                            })
                            this.renderMapMarker(data, 2)
                        }
                    }
                })
        },
        //服务对象分布
        getCustome() {
            this.$http
                .request({
                    url: "/jjyl/admin/center/customer/info/findList",
                    method: "POST",
                    data: {
                        pageNo: 1,
                        pageSize: 10000,
                        dataId: this.cid,
                        customerType: 499
                    },
                })
                .then((res) => {
                    if (res.code === 200) {
                        if (res.content != null) {
                            this.customeData = res.content.list
                            let data = this.customeData.filter(
                                (item) => item.longitude && item.latitude
                            )
                            this.renderMapMarker(data, 3)
                        }
                    }
                })
        },
        handleSearch(sign = "", id = "") {
            if (this.oldIndex === 0) {
                let self = this
                self.map.remove(this.markers)
                self.markers = []
                self.cid = self.regionId
                self.loadMap()
                // this.areaBG(this.map, this.orgName)
                // this.map.setZoom(8)
                self.getOneList()
                self.getTwoList()
                self.getThreeList()
                self.getFourList()
                self.getdayList()
                self.getSpeList()
                //定位打点
                this.getService()
                this.getStation()
                this.getCustome()
            }else{
               this.$refs.oldForm.searchPerson()
            }

        },
        renderMapMarker(data, value) {
            var image = null
            if (value === 1) {
                image = require("@/assets/img/map/map-person1.png")
            } else if (value === 2) {
                image = require("@/assets/img/map/serviceStation.png")
            } else {
                image = require("@/assets/img/map/map-person2.png")
            }
            let self = this
            var endIcon = new AMap.Icon({
                size: new AMap.Size(40, 47),
                image: image,
                imageSize: new AMap.Size(32, 36),
            })
            data.forEach((item) => {
                let marker = new AMap.Marker({
                    position: [item.longitude, item.latitude],
                    icon: endIcon,
                })

                self.markers.push(marker)
                marker.on("mouseover", (e) => {
                    marker.setTitle(item.name)
                })
                marker.on("click", (e) => {
                    self.dialogVisible = true
                    this.typeValue = value
                    if (value === 1) {
                        self.getStaffById(item.id)
                        self.infotitle = '服务人员基本信息'
                    } else if (value === 2) {
                        this.infoData = item //
                        this.infotitle = '服务站点基本信息'
                        this.infoData.personPhone = item.phone
                        this.infoData.personPhoto = item.photo
                    } else {
                        this.infoData = item
                        this.infotitle = '服务对象基本信息'
                        this.infoData.personName = item.customerName
                        this.infoData.personPhone = item.phone
                        this.infoData.personPhoto = item.photo
                        this.infoData.disabilityType=item.disabilityType
                        this.infoData.diSabiLityLeveL=item.disabilityLevel
                    }
                    // self.getElderlyInformation(item.id)
                    // self.getById(item.id)
                })
            })
            self.map.add(self.markers)
            // self.map.add(self.polygon)
            self.map.setFitView(self.polygon) //视口自适应
            self.map.setZoom(9)
        },
        getStaffById(id) {
            this.$http
                .request({
                    url: "/jjyl//admin/serviceStaffCustomerCenter/info/getServerPersonById",
                    method: "POST",
                    data: {
                        id: id,
                        orgType: 696
                    },
                })
                .then(async (res) => {
                    if (res.code == 200) {
                        this.infoData = res.content.serviceStaff
                    } else {
                        this.$message.error(res.message)
                    }
                })
        },
        //循环遍历地址
        async loopAddress() { },
        async init() {
            await Promise.all([
                this.listDept(),
                this.currentTime1(),
                this.getOneList(),
                this.getTwoList(),
                this.getThreeList(),
                this.getFourList(),
                this.getdayList(),
                this.getSpeList(),
            ]);
            this.$nextTick(() => {
                setTimeout(async () => {
                    //太慢了 先去掉
                    await this.getService()
                    await this.getStation()
                    await this.getCustome()
                }, 550)
            })
        },
        loadMap() {
            //地图加载
            return new Promise((resolve, reject) => {
                setTimeout(() => {
                    this.map = new AMap.Map("container", {
                        resizeEnable: true,
                        _mapStyle: "amap://styles/darkblue",
                        get mapStyle() {
                            return this._mapStyle
                        },
                        set mapStyle(value) {
                            this._mapStyle = value
                        },
                        zoom: 8,
                    })
                    this.areaBG(this.map, this.orgName)
                    this.map.setZoom(8)
                    // this.map.setCenter([119.015372,33.61037])
                    resolve()
                }, 300)
            })
        },
        areaBG(map, cityName) {
            let vm = this
            if (vm.polygons && vm.polygons.length > 0) {
                vm.polygons.forEach(polygon => {
                    vm.map.remove(polygon); // 从地图上移除多边形
                });
                vm.polygons = []; // 清空存储多边形的数组
            }
            console.log(cityName, 'cityName')
            AMap.service("AMap.DistrictSearch", function () {
                let opts = {
                    subdistrict: 0,
                    extensions: "all",
                    level: "district", // 查询行政级别为市
                }
                // 实例化DistrictSearch
                let district = new AMap.DistrictSearch(opts)
                district.setLevel("district")
                // 行政区查询
                console.log(cityName, 'cityName')
                district.search(`${cityName}`, function (status, result) {
                    console.log(result, 'result')
                    // 获取边界信息
                    let bounds = result.districtList[0].boundaries
                    let polygons = []
                    if (bounds) {
                        for (let i = 0, l = bounds.length; i < l; i++) {
                            // 生成行政区划polygon
                            let polygon = new AMap.Polygon({
                                map: map,
                                strokeWeight: 1,
                                path: bounds[i],
                                fillOpacity: 0.3,
                                fillColor: "#2191E6",
                                strokeColor: "#007CDB",
                            })
                            vm.polygons.push(polygon)
                            console.log(polygon)
                        }
                    }
                })
            })
        },
        //获取地址
        getDistrict(name = "中国") {
            let self = this
            return new Promise((resolve, reject) => {
                var opts = {
                    subdistrict: 3,
                    extensions: "all",
                    showbiz: false, //最后一级返回街道信息
                }
                let district = new AMap.DistrictSearch(opts)
                district.search(name, (status, result) => {
                    if (status == "complete") {
                        resolve(result.districtList[0].districtList)
                    }
                })
            }).catch((err) => {
                console.log(err)
            })
        },
    },
    get methods() {
        return this._methods
    },
    set methods(value) {
        this._methods = value
    },

    beforeDestory() {
        window.removeEventListener("resize")
    },
}
</script>
<style>
html,
body {
    overflow: hidden;
}
</style>
<style lang="less" scoped>
html {
    font-size: 20px;
}

/deep/.vue-treeselect__control {
    background: transparent !important;
    border: 1px solid #57EAE7 !important;
}

/deep/.vue-treeselect__single-value,
/deep/.vue-treeselect__placeholder {
    color: #fff !important;
    font-size: 13px;
    line-height: 26px !important
}

/deep/.vue-treeselect__control {
    height: 26px !important;
}

/deep/.vue-treeselect__menu {
    display: block !important;
    z-index: 9999;
}

/deep/.el-carousel {
    width: 100%;
    height: 100%;
}
.main_pane /deep/.el-carousel__indicators--horizontal{
    bottom:13px;
}
.small {
    color: #fff;
    font-size: 16px;
    text-align: center;
    padding-top: 15px;
}

/deep/.el-dialog__headerbtn {
    top: 13px;
}

/deep/.speinfo {
    background: #2D497D;
    border: 1px solid #91CDFF;

    .el-dialog__header {
        padding: 5px 6px;
        margin: 8px 9px;
        background: #6181BC;
        border: 1px solid #91CDFF;

        .el-dialog__title,
        .el-dialog__close {
            font-size: 13px;
            color: #fff;

            .el-dialog__headerbtn {
                top: 16px;
            }
        }
    }

    .img {
        width: 42px;
        height: 42px;
        min-width: 42px;
        border-radius: 4px;
        margin-right: 10px;
    }

    .top {
        display: flex;
        justify-content: space-between;

        .left {
            display: flex;
        }

        .right {
            width: 132px;
            height: 30px;
            line-height: 30px;
            text-align: center;
            background: #91CDFF;
            border-radius: 4px;
            color: #fff;
            font-size: 16px;
        }
    }

    .info {
        display: flex;
        flex-direction: column;
        justify-content: space-around;

        p {
            color: #fff;
            font-size: 12px;
        }

        .add {
            display: flex;

            .first {
                white-space: nowrap;
            }
        }
    }

    .el-dialog__body {
        padding: 11px 16px;
    }
}

.nameoftransition-enter-active,
.nameoftransition-leave-active {
    transition: opacity 0.5s;
}

.nameoftransition-enter,
.nameoftransition-leave-to

/* .fade-leave-active below version 2.1.8 */
    {
    opacity: 0;
}

//引入的字体样式
// @font-face {
//     font-family: "Unidtrsmled";
//    // src: url(../assets/font/UnidreamLED.ttf);
// }
.bigdata_container {
    * {
        box-sizing: content-box;
    }
}

/deep/ .el-carousel__container {
    height: 100% !important;

    .el-icon-arrow-left:before,
    .el-icon-arrow-right:before {
        color: #489aff;
        font-weight: bold;
        font-size: 22px;
    }
}

.update_info {
    display: flex;
    position: absolute;
    left: 0;
    right: 0;
    bottom: 20px;
    top: 50px;
    color: #ffffff;
    font-size: 14px;

    .info_left {
        overflow-y: scroll;
        width: 50%;
        padding: 0 12px;

        &::-webkit-scrollbar {
            width: 0 !important;
            height: 0 !important;
        }

        .left_title {
            display: flex;

            span {
                flex: 1;
                line-height: 24px;

                &:nth-child(1) {
                    flex: 0 0 60px;
                }
            }
        }

        .left_list {
            display: flex;

            .list_item {
                flex: 1;
                line-height: 48px;
                overflow: hidden; //超出的文本隐藏
                text-overflow: ellipsis; //溢出用省略号显示
                white-space: nowrap; //溢出不换行

                .index {
                    border-radius: 50%;
                    height: 24px;
                    width: 26px;
                    background: #489aff;
                    text-align: center;
                    font-size: 14px;
                    line-height: 24px;
                    font-family: Unidtrsmled;
                }
            }
        }
    }

    .info_right {
        width: 50%;
        padding: 0 12px;

        .wrapper {
            display: flex;
            justify-content: center;
            align-items: center;
            height: 100%;

            .left {
                width: 50%;
                margin-right: 12px;
            }

            .right {
                width: 50%;
            }

            img {
                width: 100%;
                height: 148px;
            }

            .label {
                margin-bottom: 12px;
                color: #489aff;
            }
        }
    }
}

/deep/ .serach_wrapper {
    z-index: 100;
    position: absolute;
    right: 5%;
    top: 30px;
    transform: translateX(-50%);
    display: flex;

    .el-button {
        color: #0291c2;
        background: #041d4d;
        border: none;
    }

    .el-button--small {
        padding: 5px 6px;
    }

    .el-input__inner {
        color: #0291c2;
        background: #102132;
        border-color: #233b87;
    }
}

.bigdata_container {
    position: relative;
    width: 100%;
    height: 100vh;
    overflow: hidden;
    background: url("../../../assets/img/homecare/bg.png") no-repeat center center;
    background-size: 100% 100%;

    .info_tisp {
        min-width: 380px;
        -webkit-box-sizing: border-box;
        box-sizing: border-box;
        border-width: 1px;
        border-style: solid;
        border-color: #ebeef5;
        position: fixed;
        left: 50%;
        top: 20px;
        -webkit-transform: translateX(-50%);
        transform: translateX(-50%);
        background-color: #edf2fc;
        border-radius: 5px;
        -webkit-transition: opacity 0.3s, top 0.4s, -webkit-transform 0.4s;
        transition: opacity 0.3s, top 0.4s, -webkit-transform 0.4s;
        transition: opacity 0.3s, transform 0.4s, top 0.4s;
        transition: opacity 0.3s, transform 0.4s, top 0.4s,
            -webkit-transform 0.4s;
        padding: 15px;
        display: flex;
        align-items: center;
        line-height: 1;

        .el-message__icon {
            margin-right: 10px;
        }
    }

    .header {
        margin: auto;
        width: 100%;
        height: 77px;
        background: url("../../../assets/img/homecare/topbg.png") no-repeat center center;
        background-size: 100%;
        text-align: center;
        line-height: 50px;
        color: #fff;
        font-size: 30px;
    }

    .bigdata_main {
        position: absolute;
        left: 0;
        top: 50px;
        right: 0;
        bottom: 0;

        .main_pane {
            // background: linear-gradient( 180deg, rgba(35,58,100,0) 0%, #233A64 100%);
            background: #1B3054;
            height: 44vh;
            position: relative;
            z-index: 999;
        }

        .main_left {
            position: absolute;
            top: 4%;
            bottom: 0%;
            left: 1%;
            width: 20%;
            overflow-y: auto;

            .main_pane1 {
                .titleBox {
                    height: 170px;
                    overflow-y: auto;

                    &::-webkit-scrollbar {
                        width: 0 !important;
                        height: 0 !important;
                    }
                }
            }

            .main_pane2 {
                .titleBox {
                    height: 23.5vh;
                }
            }

            .main_pane3 {
                .titleBox {
                    height: 21vh;
                }
            }

            &::-webkit-scrollbar {
                width: 0 !important;
                height: 0 !important;
            }
        }

        .main_center {
            position: absolute;
            top: 4%;
            // bottom: 5%;
            right: 26.5%;
            left: 22.5%;
            overflow-y: auto;

            &::-webkit-scrollbar {
                width: 0 !important;
                height: 0 !important;
            }
        }

        .serviceBg {
            background: url("../../../assets/img/homecare/bottbg.png") no-repeat;
            background-size: 100%;
            height: 50px;
            width: 262px;
            position: fixed;
            bottom: -18px;
            text-align: center;
            margin-left: 14%;

            .cont {
                display: flex;
                color: #78A1D3;
                font-size: 13px;
                justify-content: center;
                margin-top: 9px;

                div:first-child {
                    margin-right: 20px;
                }

                div:last-child {
                    margin-left: 20px;
                }
            }

            .active {
                color: #fff;
                padding-bottom: 5px;
                border-bottom: 1px solid #57EAE7
            }
        }

        .disabledtype {
            display: flex;
            justify-content: space-between;
            margin: 1.2vh 25px 0;

            li {
                font-size: 12px;
                color: #C9C9C9;
                height: 5vh;
                line-height: 5vh;
                padding: 0 12px;
                white-space: nowrap;
            }

            .active {
                background: linear-gradient(180deg, rgba(55, 103, 236, 0) 0%, #7AC2FF 78%, rgba(122, 194, 255, 0) 100%);
                opacity: 0.78;
                color: #8CFFF6;
                text-align: center;
            }
        }

        .main_right {
            position: absolute;
            top: 4%;
            bottom: 0%;
            right: 1%;
            width: 20%;
            overflow-y: auto;

            // .main_pane1,
            // .main_pane4 {
            //     height: 50vh;
            // }

            .main_pane5 {}

            &::-webkit-scrollbar {
                width: 0 !important;
                height: 0 !important;
            }
        }

        .titleHeader {
            background: url("../../../assets/img/homecare/part.png") no-repeat;
            background-size: 100%;
            height: 6vh;
            display: flex;
            flex-direction: row;
            justify-content: flex-start;

            .tititleTxttleIcon {
                display: inline-block;
                height: 5.4vh;

                img {
                    height: 17px;
                    width: 17px;
                    margin: 10px 10px;
                }
            }

            .titleTxt {
                font-size: 18px;
                line-height: 4.1vh;
                color: #fff;
                margin-left: 10%;
            }
        }

        .typeBox {
            margin: 1.5vh 2% 0;
            height: 36vh;

            ul {
                display: flex;
                justify-content: space-between;
                height: 100%;

                li {
                    width: 202px;
                    height: 100%;

                    .type {
                        width: 100%;
                        background: linear-gradient(270deg, rgba(31, 76, 162, 0) 0%, #1F4CA2 100%);
                        color: #fff;
                        font-size: 10px;

                        line-height: 30px;
                        text-indent: 12px;
                    }

                    span {
                        display: inline-block;
                        width: 7px;
                        height: 7px;
                        background: #fff;
                        border-radius: 50%;
                        margin-right: 8px;
                    }
                }
            }
        }

        .iconimg {
            // background: url("../assets/img/title-icon.png") no-repeat center
            //     center;
            background-size: 100%;
            display: flex;
            flex-direction: row;
            justify-content: flex-start;

            .titleIcon {
                display: inline-block;
                height: 37px;

                img {
                    height: 17px;
                    width: 17px;
                    margin: 10px 10px;
                }
            }

            .titleTxt {
                font-size: 16px;
                line-height: 37px;
                color: #569cea;
            }
        }

        .titleBox {
            width: 100%;
            padding: 0 12px;
            box-sizing: border-box;
            border: 1px solid #1b3074;

            ul {
                display: flex;
                flex-direction: row;
                flex-wrap: wrap;

                li {
                    margin-top: 20px;
                    width: 25%;
                    color: #ffffff;
                    text-align: center;
                    line-height: 1;

                    .bgimg {
                        font-family: Unidtrsmled;
                        font-size: 16px;
                        // background: url("../assets/img/9.png") no-repeat center
                        //     center;
                        background-size: 100%;
                        display: inline-block;
                        border-radius: 5px;
                        color: #02e0e4;
                        width: 70%;
                        height: 30px;
                        line-height: 30px;
                        margin-bottom: 5px;
                        cursor: pointer;
                    }

                    p {
                        font-family: "Unidtrsmled";
                        margin-top: 6px;
                        font-size: 12px;
                    }
                }
            }

            .li {
                padding-left: 4px;
                font-size: 14px;
                display: flex;
                margin-top: 10px;
                flex-direction: row;
                color: #fff;
                line-height: 24px;

                .img {
                    border-radius: 50%;
                    height: 24px;
                    width: 26px;
                    background: #489aff;
                    text-align: center;
                    font-size: 14px;
                    font-family: Unidtrsmled;
                }

                .txt {
                    margin-left: 20px;
                    width: 52%;
                    overflow: hidden;
                    height: 18px;
                    overflow: hidden; //超出的文本隐藏
                    text-overflow: ellipsis; //溢出用省略号显示
                    white-space: nowrap; //溢出不换行
                    text-align: center;
                }

                .time {
                    overflow: hidden; //超出的文本隐藏
                    text-overflow: ellipsis; //溢出用省略号显示
                    white-space: nowrap; //溢出不换行
                }
            }
        }

        .flex1 {
            display: flex;
            flex-direction: column;
        }

        .datatype {
            display: flex;
            justify-content: space-between;

            li {
                .data {
                    height: 30px;
                    line-height: 30px;
                    font-size: 18px;
                    color: #fff;
                    padding: 0 10px;
                    margin-bottom: 6px;
                    font-weight: bold;
                    background: linear-gradient(90deg, rgba(55, 103, 236, 0) 0%, #7AC2FF 78%, rgba(122, 194, 255, 0) 100%)
                }

                .unit {
                    font-size: 12px;
                }

                span {
                    color: #fff;
                    font-size: 14px;
                }
            }
        }

        .map {
            position: relative;
            margin-top: 30px;
            text-align: center;
            color: #4ac3ff;
            // height: 100%;
            padding: 0 24px;
            //   background: url("../assets/img/tc.png") no-repeat center center;
            // background-size: 100% 100%;

            .title_wrap {
                position: absolute;
                top: -0%;
                left: 50%;
                font-weight: bold;
                transform: translateX(-50%);
            }

            &:nth-child(1) {
                position: relative;
                top: -10px;
                position: relative;
                padding: 30px 3px 5px;
                box-sizing: border-box;
                overflow: hidden;

                .map_wrapper {
                    position: absolute;
                    left: 0;
                    right: 0;
                    top: 0;
                    bottom: 0;
                    // background: url("../assets/img/tc.png") no-repeat center
                    //     center;
                    background-size: 100% 100%;
                }
            }

            &:nth-child(1) {
                margin-top: 4px;
            }
        }
    }

    .time {
        font-size: 14px;
        color: #fff;
        top: 37px;
        position: absolute;
        left: 20px;
    }

    .quanp {
        width: 20px;
        height: 20px;
        float: right;
        position: absolute;
        top: 31px;
        right: 28px;
        z-index: 999;

        .screen {
            width: 100%;
            height: 100%
        }
    }
}

// 弹框步骤条样式
/deep/ #el-step {
    margin-bottom: 30px;

    .el-step__icon.is-text {
        border-radius: 5px;
    }

    .is-finish .el-step__icon {
        background: #409eff;
    }

    .el-step__icon {
        width: auto;
        padding: 22px 38px;
        color: #ffffff;
        cursor: pointer;
        border: none;
        background: #c0c4cc;
    }

    .el-step {
        height: 40px;
        margin-bottom: 24px;
    }

    .el-step.is-horizontal .el-step__line {
        top: 20px;
    }
}

.check_form_item {
    img {
        width: 100px;
        height: 100px;
    }
}

.el-step.is-center /deep/.el-step__line {
    right: -27%;
    left: 73%;
    border-top: 1px solid #c8b226;
    background-color: transparent;
}

/deep/ .check_form_item,
/deep/ .acceptance_form_item {
    display: flex;
    flex-direction: column;

    .el-form-item__label {
        width: 100% !important;
        margin-bottom: 12px;
        text-align: left;
        border-bottom: 1px solid #c0c4cc;
    }

    /deep/ .el-form-item__content {
        margin-left: 0 !important;
    }
}

.user_info {
    /deep/ .el-form-item {
        margin-bottom: 20px;
    }
}

// /deep/ .check_form_item {
//   display: flex;
// }
.check_upload {
    display: inline-block;

    &+.check_upload {
        margin-left: 12px;
    }

    .avatar-uploader {
        line-height: 1;
    }

    .photo {
        font-size: 0;

        img {
            width: 100px;
            height: 100px;
        }
    }

    /deep/ .el-button {
        width: 100px;
        padding: 0;
        line-height: 35px;
        margin-top: 5px !important;
    }
}

.photo {
    font-size: 0;

    img {
        width: 160px;
        height: 160px;
    }
}

/deep/.el-dialog {
    background: #092267;
    opacity: 0.8;
}

#el-step /deep/.el-step__icon {
    background: none;
    color: #c8b226;
    border: 1px solid #c8b226;
}

#el-step /deep/.is-finish .el-step__icon {
    background: #c8b226;
    color: #fff;
}

/deep/.dialog_container .el-dialog__footer {
    background: #092267;
    border-top: none;
    opacity: 0.8;
    text-align: center;

    .el-button {
        border: 1px solid #4a93dc;
        color: #fff;
        margin-bottom: 8px;
        background: #092267;
    }

    .el-button:hover {
        background: #092267;
    }
}

/deep/.el-form-item__label {
    color: #fff;
}

.el-input.is-disabled /deep/.el-input__inner {
    background-color: #85b6db;
    color: #fff;
    opacity: 0.55;
    border: none;
}

.el-textarea.is-disabled /deep/.el-textarea__inner {
    background-color: #85b6db;
    color: #fff;
    border: none;
    opacity: 0.55;
}

/deep/.el-checkbox__input.is-disabled.is-checked .el-checkbox__inner {
    background-color: #092267;
    border-color: #409eff;
}

/deep/.el-checkbox__input.is-disabled .el-checkbox__inner {
    background-color: #092267;
    border-color: #409eff;
}

.assessment_upload {
    height: auto;
    width: 100%;
    overflow: hidden;
    position: relative;

    ul {
        width: auto;
        height: auto;
        overflow-x: scroll;
        overflow-y: hidden;
        display: flex;
        justify-content: space-between;

        li {
            margin-left: 20px;
            width: 150px;

            .avatar-uploader {
                width: 100%;

                img {
                    width: auto;
                    min-width: 160px;
                    height: 120px;
                }
            }

            .el-button {
                width: 100%;
            }

            &:nth-child(1) {
                margin-left: 0;
            }
        }
    }
}
</style>
